import React from 'react'

class NotFound extends React.Component {
  render() {
    return <div>404: Not Found</div>
  }
}

export { NotFound as NotFoundPage };